<p-toast></p-toast>
<div class="grid">
    <div class="col-12">
        <form [formGroup]="confirmForm">
            <p-messages [(value)]="messages" [closable]="true" />
            <div
                class="p-fluid flex flex-column justify-content-start align-items-start w-full"
            >
                <h4>{{pageTitle}}</h4>
                <div class="field col-12 md:col-6 mb-0 w-full">
                    <label for="confirmationDate" class="text-sm text-500"
                        >{{"Payment Date"| translate}}</label
                    >
                    <p-calendar
                        id="confirmationDate"
                        formControlName="paymentDate"
                        [placeholder]="'SELECT_PAYMENT_DATE' | translate"
                        [minDate]="minDate"
                        [maxDate]="maxDate"
                        [showIcon]="true"
                    ></p-calendar>
                </div>
                <div class="field col-12 md:col-6 mb-0 w-full">
                    <label for="notes" class="text-sm text-500"
                        >{{'Additional notes' | translate}}</label
                    >
                    <textarea
                        id="notes"
                        formControlName="notes"
                        rows="3"
                        pInputText
                    ></textarea>
                </div>
                <div class="ml-4 mt-4">
                    <p-checkbox
                        formControlName="confirmAction"
                        [binary]="true"
                    />
                    <label for="ny" class="ml-2"
                        >{{'CONFIRMATION_WARNING' | translate}}</label
                    >
                </div>
                <div class="flex gap-3 mt-6 w-full justify-content-center">
                    <p-button
                        [label]="'CANCEL' | translate"
                        icon="pi pi-times"
                        (click)="ref.close()"
                        severity="danger"
                        class="p-button-secondary"
                    ></p-button>
                    <p-button
                        [label]="'PROCEED' | translate"
                        icon="pi pi-check"
                        severity="success"
                        (click)="confirmClicked()"
                        [disabled]="confirmForm.invalid"
                    ></p-button>
                </div>
            </div>
        </form>
    </div>
</div>
